import { debounce } from '../utility/debounce'

export default function init(attr = 'data-bg-color', containerAttr = 'data-bg-color-container') {
	
	const els = [...document.querySelectorAll(`[${attr}]`)].reverse()
	const containers = new Map();
	els.forEach(el => {
		containers.set(el, el.closest(`[${containerAttr}]`) || document.body)
	})

	function setColour(el) {
		const container = containers.get(el)
		const value = el.getAttribute(attr)
		if (value !== null) container.style.backgroundColor = value
	}

	function update() {
		const midpoint = window.innerHeight * 0.55
		for (const el of els) {
			const rect = el.getBoundingClientRect()
			const isOverMidpoint = rect.top <= midpoint && rect.bottom >= midpoint
			if (isOverMidpoint) {
				setColour(el)
			}
		}
	}

	const debouncedUpdate = debounce(update)

	function initialColour() {
		const containers = [...document.querySelectorAll(`[${containerAttr}]`)]
		containers.map(container => {
			const first = container.querySelector(`[${attr}]`)
			if (first) setColour(first)
		})
	}

	function setupEvents() {
		window.addEventListener('load', update)
		window.addEventListener("DOMContentLoaded", update)
		window.addEventListener('scroll', update)
		window.addEventListener('resize', debouncedUpdate)
	}

	setupEvents()
	initialColour()
}